(function(konto) {
	konto.sf = {};
} (konto = window.konto));